import FormField from "./FormField";

const SelectField = ({
  label,
  name,
  value,
  onChange,
  options,
  required,
  description,
}) => {
  return (
    <FormField label={label} required={required} description={description}>
      <select
        name={name}
        value={value || ""}
        onChange={onChange}
        className="flex h-10 w-full rounded-sm border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 border-gray-200"
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </FormField>
  );
};

export default SelectField;
